<template>
  <div class="course_center">
    <secondary-banner title="课程微课资源库" :img="require('@/assets/images/usertype/banner_er.png')"></secondary-banner>
    <div class="content secondary_page_bg">
      <div class="inner">
        <div class="header_search">
          <div class="search_header">
            <el-autocomplete placeholder="请输入内容" style="width: 400px" @keyup.enter.native="handleCourse"
              :fetch-suggestions="querySearch" v-model="queryParams.title" class="input-with-select"
              @select="handleSelect" ref="el_auto" clearable @clear="$refs.el_auto.activated = true">
              <div slot-scope="{ item }" style="display: flex;align-items: center;justify-content: space-between">
                <div class="name">{{ item.content }}</div>
                <i class="el-icon-close" @click.stop="searchDelete(item)"> </i>
              </div>
              <el-button slot="append" icon="el-icon-search" @click="handleCourse"></el-button>
            </el-autocomplete>
          </div>
          <div class="search">
            <div class="search_list">
              <span v-for="(item, index) in workList" :key="item.id" @click="handleWork(item, index)"
                :class="[active == index ? 'active' : '']">{{ item.title }}</span>
            </div>
          </div>
        </div>

        <div class="course_list" v-loading="loading" v-if="privacyCourse.length > 0 || loading">
          <!-- <div class="course_item" v-for="(item, index) in privacyCourse" :key="index">
            <div class="left">
              <el-image
                style="width: 100%; height: 100%; display: block; background: #292929"
                :src="item.cover || defaultImg"
                fit="fill"
                lazy
              ></el-image>
            </div>
            <div class="right">
              <div class="course_title">{{ item.title }}</div>
              <div class="school_item">
                <span class="teacher">{{ item.teacherName }}</span>
              </div>
              <div class="course_sub_title">{{ item.description }}</div>
              <div class="course_footer">
                <div class="time_person">
                  <span>
                    <i class="el-icon-time"></i>
                    {{
                      item.classHours
                        ? parseInt((item.classHours / 60 / 45) * 100) / 100 + "课时"
                        : ""
                    }}
                  </span>
                  <span>
                  </span>
                </div>
                <a class="button" href="javascript:;" @click="getHandleDetail(item)"
                  >了解详情</a
                >
              </div>
            </div>
          </div> -->
          <new-cursordetail class="cursor_item" v-for="(item, index) in privacyCourse"
            @setHandleDetail="getHandleDetailCharge" @setEqual="getEqual" :cursorDetail="item" :key="index"
            :d-height="dHeight" />
        </div>
        <div style="text-align: center" v-if="total > 0">
          <el-pagination background layout="total,prev, pager, next" :total="total" :page-size="queryParams.pageSize"
            :current-page="queryParams.pageNum" @current-change="handleCurrentChange" :hide-on-single-page="false">
          </el-pagination>
        </div>
        <el-empty description="暂无课程" v-if="!loading && privacyCourse.length == 0"></el-empty>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getWebListProfession,
  getWebListCourse,
  publicCourse,
  postbrowse,
  listSearchHistory,
  addSearchHistory,
  delSearchHistory
} from "@/api/home";
import NewCursordetail from "@/components/NewCursordetail";
import SecondaryBanner from "@/components/SecondaryBanner";
export default {
  name: "CourseCenter",
  components: {
    NewCursordetail,
    SecondaryBanner,
  },
  data() {
    return {
      workList: [],
      active: 0,
      privacyCourse: [],
      publicCourses: [],
      loading: false,
      dHeight: 0,
      defaultImg: require("@/assets/images/cursorDefault.png"),
      queryParams: {
        professionId: "",
        title: "",
        pageNum: 1,
        pageSize: 8,
      },
      restaurants: [],
      total: 0,
    };
  },
  async created() {
    this.$store.commit("user/SET_TABINDEX", 1030);
    await this.getWebListProfession();
    if (this.workList.length > 0) {
      this.queryParams.professionId = this.workList[0].id;
      await this.getWebListCourse(this.queryParams);
    }
    this.getHistoryList()
    // await this.publicCourse()
  },
  methods: {
    async getWebListProfession() {
      await getWebListProfession().then((res) => {
        if (res.code == 200) {
          this.workList = res.rows;
        }
      });
    },
    async getWebListCourse(params) {
      this.loading = true;
      await getWebListCourse(params)
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.privacyCourse = res.rows;
            this.total = res.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getWebListCourse(this.queryParams);
    },
    async handleWork(item, index) {
      this.active = index;
      this.queryParams.professionId = item.id;
      this.queryParams.pageNum = 1;
      this.queryParams.title = '';
      this.getWebListCourse(this.queryParams);
    },
    handleCourse() {
      this.queryParams.pageNum = 1;
      this.getWebListCourse(this.queryParams);
      this.addSearch()
    },
    // 搜索历史
    handleSelect(item) {
      console.log(item)
      this.queryParams.title = item.content
      this.getWebListCourse(this.queryParams)
    },

    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.content.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    async getHistoryList() {
      let cookie_val = this.getCookie('online_training_web_token') || null;
      if (!cookie_val) return
      await listSearchHistory({
        userId: this.$store.state.user.userId,
        pageNum: 1,
        pageSize: 5,
      }).then((res) => {
        if (res.code == 200) {
          this.restaurants = res.rows;
          this.$forceUpdate()
        }
      });
    },
    addSearch() {
      let cookie_val = this.getCookie('online_training_web_token') || null;
      if (!cookie_val) return
      if (!this.queryParams.title) return
      addSearchHistory({
        userId: this.$store.state.user.userId,
        content: this.queryParams.title
      }).then((res) => {
        if (res.code == 200) {
          this.restaurants = res.rows;
          this.getHistoryList()
        }
      });
    },
    searchDelete(item) {
      console.log('删除', item)
      delSearchHistory(item.id).then((res) => {
        if (res.code == 200) {
          this.getHistoryList()
          this.$refs.el_auto.activated = false
        }
      });
    },


    // getHandleDetail(data) {
    //   var rourl = "";
    //   if (data.courseMyType) {
    //     rourl = this.$router.resolve({ path: "/openclass", query: { id: data.id } });
    //   } else {
    //     rourl = this.$router.resolve({
    //       path: "/coursedetails",
    //       query: { id: data.id, professionId: data.professionId },
    //     });
    //     //浏览次数
    //     this.browseadd(data.id);
    //   }
    //   window.open(rourl.href);
    // },
    // openclass(data) {
    //   let rourl = this.$router.resolve({ path: "/openclass", query: { id: data.id } });
    //   window.open(rourl.href);
    // },

    getHandleDetailCharge(data) {
      let rourl = this.$router.resolve({
        path: "/coursedetails",
        query: { id: data.id, professionId: data.professionId },
      });
      window.open(rourl.href);
      //浏览次数
      this.browseadd(data.id);
    },
    getEqual(h) {
      this.dHeight = this.dHeight < h ? h : this.dHeight;
    },
    // 增加浏览次数
    browseadd(courseId) {
      let datas = {
        courseId: courseId,
      };
      postbrowse(datas).then((res) => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.course_center {
  .content {
    padding: 72px 0 15px;
  }

  .inner {
    background-color: #fff;
    padding-bottom: 98px;
  }
  .header_search{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 35px;
  }
  .search {
    font-size: 15px;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: flex-start;

    .search_list {
      display: flex;
      flex-wrap: wrap;

      span {
        padding: 8px 16px;
        cursor: pointer;
        font-size: 18px;
        white-space: nowrap;
        border: 1px solid #045923;
        border-radius: 30px;
        margin: 5px 8px;

        &.active {
          background: #045923;
          color: #ffffff;
        }
      }
    }
  }

  // 搜索
  .search_header {
    width: 353px;
    height: 40px;
    display: flex;
    align-items: center;

    ::v-deep .el-input-group__append {
      border-bottom-right-radius: 20px;
      border-top-right-radius: 20px;
      background: none;
      border-left: none;
    }

    ::v-deep .el-input__inner {
      border-bottom-left-radius: 20px;
      border-top-left-radius: 20px;
      border-right: none;

      &:focus {
        border-color: #dcdfe6;
      }
    }
  }

  .course_list {
    display: flex;
    flex-wrap: wrap;
    margin-left: -7px;
    margin-right: -7px;
    min-height: 295px !important;

    .cursor_item {
      width: 25%;
      margin-bottom: 40px;

      ::v-deep .cursor_inner {
        background: #fff;
      }
    }
  }
}
</style>
